import {useState} from 'react';

import Link from '../elements/Link';
import {motion, AnimatePresence} from 'framer-motion';

const Accordion = ({i, expanded, setExpanded, label, links}: any) => {
  const isOpen = i === expanded;
  return (
    <>
      <motion.div
        className={`text-teal flex cursor-pointer flex-row items-center justify-between gap-x-12 border-b-[2px] border-[#ffffff20] ${
          i !== 0 ? 'py-4 md:py-7' : 'pb-4 pt-0 md:pb-7 md:pt-3'
        }`}
        initial={false}
        onClick={() => setExpanded(isOpen ? false : i)}
      >
        <p className="blockH7 font-bold">{label}</p>
        <motion.span
          key={'footer-links'}
          initial={{opacity: 0}}
          animate={{opacity: 1}}
          exit={{opacity: 0}}
          className="blockH6"
        >
          {isOpen ? '-' : '+'}
        </motion.span>
      </motion.div>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.section
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: {opacity: 1, height: 'auto'},
              collapsed: {opacity: 0, height: 0},
            }}
            transition={{duration: 0.8, ease: [0.04, 0.62, 0.23, 0.98]}}
          >
            <motion.div
              variants={{
                collapsed: {opacity: 0, scale: 1},
                open: {opacity: 1, scale: 1},
              }}
              transition={{duration: 0.8}}
              className="flex flex-col gap-y-2 py-4"
            >
              {links?.map((link: any, i: number) => (
                <Link key={i} link={link} className="blockH10">
                  {link?.title}
                </Link>
              ))}
            </motion.div>
          </motion.section>
        )}
      </AnimatePresence>
    </>
  );
};

export function MobileColumns({links}: any) {
  const [expanded, setExpanded] = useState(0);

  return (
    <div className="w-full md:hidden">
      {links?.map((row: any, i: number) => (
        <Accordion
          key={i}
          i={i}
          expanded={expanded}
          setExpanded={setExpanded}
          {...row}
        />
      ))}
    </div>
  );
}

export function Columns({links}: any) {
  return (
    <div className="hidden items-start gap-x-14 md:flex">
      {links?.map(({label, links}: any, index: number) => (
        <div key={index} className="flex w-[120px] flex-col gap-y-3">
          <span className="richH7 font-bold">{label}</span>
          {links?.map((link: any, i: number) => (
            <Link key={i} link={link} className="blockH10">
              {link?.title}
            </Link>
          ))}
        </div>
      ))}
    </div>
  );
}
